import { useCallback } from 'react';
import {
  NavigateOptions,
  To,
  useLocation,
  useNavigate as useRouterNavigate,
} from 'react-router-dom';

type UseNavigate = {
  lastPathname?: string;
  navigate(href: To, options?: NavigateOptions): void;
  goBack(): void;
};

export function useNavigate(): UseNavigate {
  const location = useLocation();
  const navigate = useRouterNavigate();

  return {
    lastPathname: location.state?.lastPathname,
    navigate: useCallback(
      (href: To, options?: NavigateOptions) => {
        const lastPathname = options?.replace ? href : location.pathname;

        return navigate(href, {
          ...options,
          state: { lastPathname },
        });
      },
      [location.pathname, navigate],
    ),
    goBack: useCallback(() => {
      navigate(-1);
    }, [navigate]),
  };
}
